import { render, staticRenderFns } from "./servicios.vue?vue&type=template&id=1057cb3a&"
import script from "./servicios.vue?vue&type=script&lang=js&"
export * from "./servicios.vue?vue&type=script&lang=js&"
import style0 from "./servicios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports